import "../../css/styles.css";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import React, {Component} from "react";
import ReactPlayer from 'react-player';
import Countdown from 'react-countdown-now';
import moment from 'moment';
import TelevisionBreakpoint from "../../components/responsive_utilities/television_breakpoint";
import DesktopBreakpoint from "../../components/responsive_utilities/desktop_breakpoint";
import TabletBreakpoint from "../../components/responsive_utilities/tablet_breakpoint";
import PhoneBreakpoint from "../../components/responsive_utilities/phone_breakpoint";
import { MultiSpeciesScoresHorzPhone } from "../../components/CompsPhone/MultiSpeciesScoresHorzPhone";
import { MultiSpeciesScoresHorz } from "../../components/MultiSpeciesScoresHorz";
import { MultiSpeciesHeaviest } from "../../components/MultiSpeciesHeaviest";
import { TournamentDetails} from "../../components/TournamentDetails";
import { TournamentDetailsTv} from "../../components/CompsTv/TournamentDetailsTv";
import { TournamentDetailsPhone} from "../../components/CompsPhone/TournamentDetailsPhone";
import { SponsorsScroller} from "../../components/SponsorsScroller";
import { SponsorsScrollerTv} from "../../components/SponsorsScrollerTv";
import { Scroller } from "../../components/Scroller";
import { ScrollerMobile } from "../../components/CompsPhone/ScrollerMobile";
import { SpeciesScores } from "../../components/SpeciesScores";
import { SpeciesScoresPhone } from "../../components/CompsPhone/SpeciesScoresPhone";
import { SpeciesScoresSingle } from "../../components/SpeciesScoresSingle";
import { Logs } from "../../components/Logs";
import { LogsTv } from "../../components/CompsTv/LogsTv";
import { LogsPhone } from "../../components/CompsPhone/LogsPhone";
import { TideChart } from "../../components/TideChart";
import { TideChartPhone } from "../../components/CompsPhone/TideChartPhone";
var Sound = require('react-sound').default; 


const dragSound = require('../../media/drag.wav');

const sponsorLogos = ['https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/bisbees_b_b_2018_sponsors%2Farnian.jpeg?alt=media&token=f7883bb7-038e-4591-9a2d-47e2b1f6d3ea', 'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/bisbees_b_b_2018_sponsors%2FbajaCalSur.png?alt=media&token=8d12014f-fb36-499b-aeee-2850197a8887', 'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/bisbees_b_b_2018_sponsors%2FbajaCantina.png?alt=media&token=5dbd240f-2ff5-4c87-9f0d-5833ebb81751', 'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/bisbees_b_b_2018_sponsors%2FbisbeesFishWildlife.png?alt=media&token=1db51648-c24b-4299-b756-0cc2ee6074c7', 'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/bisbees_b_b_2018_sponsors%2Fbomberos.jpeg?alt=media&token=a5180872-85f7-4b46-b8ee-ba4804ae6a3b', 'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/bisbees_b_b_2018_sponsors%2FcatchStat.png?alt=media&token=6bc94606-d8b9-4522-b095-e33854e6dc3d','https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/bisbees_b_b_2018_sponsors%2Fcosta.png?alt=media&token=82b0c044-4f38-4c3a-a647-3a3143363ef5', 'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/bisbees_b_b_2018_sponsors%2FexploreSat.png?alt=media&token=ccc20a12-e2d1-4282-86f0-40bdb5800b7e', 'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/bisbees_b_b_2018_sponsors%2FfeedingLosCabos.jpeg?alt=media&token=b7c369cd-b25d-4f89-87fc-ed13403754bd', 'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/bisbees_b_b_2018_sponsors%2Fhiltons.png?alt=media&token=8d5219e9-a3ce-4a19-b2a2-45d541d754be', 'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/bisbees_b_b_2018_sponsors%2Fhostipen.png?alt=media&token=014ea298-acc3-4387-8eb4-9288ad6533e4', 'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/bisbees_b_b_2018_sponsors%2Figy.png?alt=media&token=6698be37-5bcd-423f-92de-766ca6813c25', 'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/bisbees_b_b_2018_sponsors%2Finfinitum.jpeg?alt=media&token=ac3aa580-68be-4e58-b51d-71c6a2fe56fb', 'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/bisbees_b_b_2018_sponsors%2Fletty.jpeg?alt=media&token=c7012a02-c8e8-4ef2-9e5b-d9988cb3d99f', 'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/bisbees_b_b_2018_sponsors%2FLosCabos.png?alt=media&token=07d21cfc-0490-42f2-be6e-27b81197153d', 'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/bisbees_b_b_2018_sponsors%2FlosCabosChildren.jpeg?alt=media&token=24e14f89-d728-4658-90a5-d85e63cff67d', 'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/bisbees_b_b_2018_sponsors%2Flr.jpeg?alt=media&token=cee9373c-071e-4093-be4c-aecfc9dda155', 'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/bisbees_b_b_2018_sponsors%2FmarineTrophies.jpeg?alt=media&token=158e865f-c031-4a82-84aa-9c3540b6d67f', 'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/bisbees_b_b_2018_sponsors%2Fmedano.jpeg?alt=media&token=63d6ce09-2f12-4694-8ea8-401f4ad446cb', 'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/bisbees_b_b_2018_sponsors%2FmoldCraft.jpeg?alt=media&token=313a2a5f-b3cc-4485-9c4f-8cd0a71af5db', 'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/bisbees_b_b_2018_sponsors%2FnoWorries.png?alt=media&token=2f790ff0-357b-4585-b74e-93396d6d4555', 'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/bisbees_b_b_2018_sponsors%2Forca.png?alt=media&token=a721cee8-fd25-4282-91db-ebd10a2bc1fa', 'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/bisbees_b_b_2018_sponsors%2Fpelagic.png?alt=media&token=2311e559-7777-42bd-a9b2-548983399086', 'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/bisbees_b_b_2018_sponsors%2FpuertoParaiso.png?alt=media&token=fe15b2c5-3ea1-4ea9-b741-c22f722f4c2e', 'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/bisbees_b_b_2018_sponsors%2FscaleMaster.png?alt=media&token=557934c0-1e53-47a1-aa51-d9a1997e5559', 'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/bisbees_b_b_2018_sponsors%2Fseakeeper.jpeg?alt=media&token=01c64000-8c42-480a-850f-32c6418854b1', 'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/bisbees_b_b_2018_sponsors%2FsevenStar.gif?alt=media&token=eeaa7f2d-4f88-41f4-8d50-f523db513e6f', 'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/bisbees_b_b_2018_sponsors%2FtequilaRev.jpeg?alt=media&token=a955d195-98a9-4dc1-ae26-4edac94aefdb', 'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/bisbees_b_b_2018_sponsors%2FvalleyPower.jpeg?alt=media&token=bdb02fb7-7b7b-4213-83fe-738d801ad269'];

var firebase = require('firebase/app');
require('firebase/database');

class BisbeesLosCabos extends Component {
  
  constructor() {
    super();
    this.state = {
      tourDay1: '',
      tourDay2: '',
      tourDay3: '',
      tourDay4: '',
      countDownDate: '',
      buttonStatus: 'current',
      buttonStatus1: 'notCurrent',
      buttonStatus2: 'notCurrent',
      buttonStatus3: 'notCurrent',
      buttonStatus4: 'notCurrent',
      tournamentLogo: '',
      tournamentName: '',
      tournament: [],
      boats: [],
      anglersRaw: {},
      species: [],
      speciesRaw: {},
      boatsRaw: {},
      logs: [],
      logsOne: [],
      logsTwo: [],
      logsThree: [],
      logsFour: [],
      currentLogs: [],
      fishLogs: [],
      hookups: [],
      hps: [],
      boatLogs: [],
      boatTotals: [],
      boatTotalsOne: [],
      boatTotalsTwo: [],
      boatTotalsThree: [],
      boatTotalsFour: [],
      boatScores: [],
      boatScoresArray: [],
      showAll: true,
      showDay1: false,
      showDay2: false,
      showDay3: false,
      showDay4: false,
      newLog: false,
      newItem: false,
      playing: 'STOPPED',
      vidPlaying: true,
      loading: true,
      newFishLog: [],
      vidLogs: [],
      currentVideo: '',
      boardId: '',
      boardName: '',
      videoVis: 'visible',
      displayVis: 'inline',
      loadingVis: 'none',
      loadingVis2: 'inline',
      speciesPoints: [],
      boatFishLogs: []
    };
    this.baseRef = firebase.database().ref('/');
    this.ref = firebase.database().ref('tournaments');
    this.tourRef = firebase.database().ref('tournaments/-LK2pCptMYQPMnYPuRrb');
  }
  
  componentWillMount() {
    this.tourRef.on('value', this.handleTournamentUpdate); 
    this.tourRef.child('fishLogs').on('child_added', this.handleFishLogAdded);
    this.tourRef.child('fishLogs').on('child_changed', this.handleFishLogChanged);
    this.baseRef.child('refresh').on('child_changed', this.reloadPage);
  }
  
  componentDidMount() {
     window.addEventListener("keyup", this.keyHandling);
  }
  
  componentWillUnmount() {
    window.removeEventListener("keyup", this.keyHandling);
    this.tourRef.off('value', this.handleTournamentUpdate); 
    this.tourRef.child('fishLogs').off('child_added', this.handleFishLogAdded);
    this.tourRef.child('fishLogs').off('child_changed', this.handleFishLogChanged);
    this.baseRef.child('refresh').off('child_changed', this.reloadPage);
  }
  
  keyHandling = (e) => {
    if(e.keyCode === 179) {
      this.setState({
        vidPlaying: !this.state.vidPlaying
      })
    }
  }
  
  reloadPage = () => {
    window.location.reload(true);
  }
  
  handleTournamentUpdate = (snapshot) => {
    if(snapshot.val().fishLogs) {
      var fishLogsArray = Object.entries(snapshot.val().fishLogs);
    }
    var fishLogsList = [];
    var hookupsList = [];
    var speciesArray = Object.entries(snapshot.val().species);
    var speciesList = [];
    var boatsArray = Object.entries(snapshot.val().boats);
    var boatsList = [];
    let vidLogs = [
      {
        id: 1,
        boatId: '',
        boatName: '',
        speciesId: '',
        speciesName: '',
        anglerId: '',
        anglerName: ',',
        lbs: '',
        catchDate: '',
        clipUrl: 'https://youtu.be/qwlm-AZjsok '
      },
      {
        id: 1,
        boatId: '',
        boatName: '',
        speciesId: '',
        speciesName: '',
        anglerId: '',
        anglerName: ',',
        lbs: '',
        catchDate: '',
        clipUrl: 'https://www.youtube.com/watch?v=WuHKEpdA154'
      },
      {
        id: 1,
        boatId: '',
        boatName: '',
        speciesId: '',
        speciesName: '',
        anglerId: '',
        anglerName: ',',
        lbs: '',
        catchDate: '',
        clipUrl: 'https://www.youtube.com/watch?v=EgyOOgnQuvM'
      },
      {
        id: 2,
        boatId: '',
        boatName: '',
        speciesId: '',
        speciesName: '',
        anglerId: '',
        anglerName: ',',
        lbs: '',
        catchDate: '',
        clipUrl: 'https://www.youtube.com/watch?v=VCsB-abHMXA'
      },
      {
        id: 1,
        boatId: '',
        boatName: '',
        speciesId: '',
        speciesName: '',
        anglerId: '',
        anglerName: ',',
        lbs: '',
        catchDate: '',
        clipUrl: 'https://www.youtube.com/watch?v=qb5G82C5X_8'
      },
      {
        id: 3,
        boatId: '',
        boatName: '',
        speciesId: '',
        speciesName: '',
        anglerId: '',
        anglerName: ',',
        lbs: '',
        catchDate: '',
        clipUrl: 'https://www.youtube.com/watch?v=p8cyCAhtPjs'
      },
      {
        id: 4,
        boatId: '',
        boatName: '',
        speciesId: '',
        speciesName: '',
        anglerId: '',
        anglerName: ',',
        lbs: '',
        catchDate: '',
        clipUrl: 'https://www.youtube.com/watch?v=MwOKpBxBkVk'
      },
    ];
    if(fishLogsArray) {
      fishLogsArray.forEach((log) => {
        if(log[1].clipUrl){
          vidLogs.push({
          id: log[0],
          boatId: log[1].boatId,
          boatName: log[1].boatName,
          speciesId: log[1].speciesId,
          speciesName: log[1].speciesName,
          anglerId: log[1].anglerId,
          anglerName: log[1].anglerName,
          lbs: log[1].fishLbs,
          hookedupDate: log[1].hookedupDate,
          catchDate: log[1].catchDate,
          clipUrl: log[1].clipUrl,
          status: log[1].status
          });
        }
        fishLogsList.push({
          id: log[0],
          boatId: log[1].boatId,
          boatName: log[1].boatName,
          speciesId: log[1].speciesId,
          speciesName: log[1].speciesName,
          anglerId: log[1].anglerId,
          anglerName: log[1].anglerName,
          lbs: log[1].fishLbs,
          hookedupDate: log[1].hookedupDate,
          catchDate: log[1].catchDate,
          clipUrl: log[1].clipUrl,
          status: log[1].status
        });
        if (log[1].status === 'hooked up'){
          hookupsList.push ({
            id: log[0],
            boatId: log[1].boatId,
            boatName: log[1].boatName,
            speciesId: log[1].speciesId,
            speciesName: log[1].speciesName,
            anglerId: log[1].anglerId,
            anglerName: log[1].anglerName,
            lbs: log[1].fishLbs,
            hookedupDate: log[1].hookedupDate,
            status: log[1].status
          })
        }
      })
    }
    
    speciesArray.forEach((specie) => {
      speciesList.push({
        id: specie[0],
        name: specie[1].name,
        points: specie[1].points,
        scoreType: specie[1].scoreType,
        speciesImageUri: specie[1].speciesImageUri
      })
    })
    
    boatsArray.forEach((boat) => {
      boatsList.push({
        id: boat[0],
        name: boat[1].name,
        photoURL: boat[1].photoUrl,
      })
    })
    
    var countDownDate = moment.utc(new Date(snapshot.val().day1Date)).format('LLL');
    
    var tournament = {
      tournamentId: snapshot.key,
      tournamentName: snapshot.val().name,
      tournamentLogo: snapshot.val().logoUri,
      venue: snapshot.val().venue,
      captMeetingTime: snapshot.val().captMeetingTime,
      captMeetingLoc: snapshot.val().captMeetingLoc,
      tourDay1: snapshot.val().day1Date,
      tourDay2: snapshot.val().day2Date,
      tourDay3: snapshot.val().day3Date,
      tourDay4: snapshot.val().day4Date,
      anglersRaw: snapshot.val().anglers,
      boatsRaw: snapshot.val().boats,
    }
    
    this.setState({
      tournamentId: snapshot.key,
      tournamentName: snapshot.val().name,
      tournamentLogo: snapshot.val().logoUri,
      tourDay1: snapshot.val().day1Date,
      tourDay2: snapshot.val().day2Date,
      tourDay3: snapshot.val().day3Date,
      tourDay4: snapshot.val().day4Date,
      species: speciesList, 
      speciesRaw: snapshot.val().species,
      anglersRaw: snapshot.val().anglers,
      boatsRaw: snapshot.val().boats,
      boats: boatsList,
      hps: hookupsList,
      vidLogs,
      newItem: true,
      currentVideo: vidLogs[0],
      fishLogs: this.sortFishLogs(fishLogsList),
      countDownDate,
      tournament
    });
    this.getBoats();
  }
  
  isEmpty(obj) {
    for(var key in obj) {
        if(obj.hasOwnProperty(key))
            return false;
    }
    return true;
  }
  
  
  sortFishLogs(logs){
    logs.sort(function(a,b){
      var c = new Date(a.catchDate);
      var d = new Date(b.catchDate);
      return c-d;
    });
    
    logs.reverse();
    return logs
  }
  
  handleFishLogAdded = (snapshot) => {
    if (!this.state.newItem) return;
    var fishLogs = this.state.fishLogs;
    var vidLogs = this.state.vidLogs;
    if(snapshot.val().catchDate) {
      var cd = this.formatDate(snapshot.val().catchDate);
    } else {
      var cd = null;
    }
    if(snapshot.val().hookedupDate) {
      var hd = this.formatDate(snapshot.val().hookedupDate);
    } else {
      var hd = null;
    }
    if(snapshot.val().clipUrl){
      vidLogs.push({
        id: snapshot.key,
        boatId: snapshot.val().boatId,
        boatName: snapshot.val().boatName,
        speciesId: snapshot.val().speciesId,
        speciesName: snapshot.val().speciesName,
        lbs: snapshot.val().fishLbs,
        anglerId: snapshot.val().anglerId,
        anglerName: snapshot.val().anglerName,
        hookedupDate: hd,
        catchDate: cd,
        clipUrl: snapshot.val().clipUrl,
        status: snapshot.val().status
        });
    }
      fishLogs.unshift({
        id: snapshot.key,
        boatId: snapshot.val().boatId,
        boatName: snapshot.val().boatName,
        speciesId: snapshot.val().speciesId,
        speciesName: snapshot.val().speciesName,
        lbs: snapshot.val().fishLbs,
        anglerId: snapshot.val().anglerId,
        anglerName: snapshot.val().anglerName,
        photoUrl: snapshot.val().photoUrl,
        status: snapshot.val().status,
        hookedupDate: hd,
        catchDate: cd,
        });
      this.setState({
        vidLogs,
        playing: 'PLAYING',
        newLog: true,
        videoVis: 'hidden',
        displayVis: 'none',
        newFishLog: {
          boatId: snapshot.val().boatId,
          boatName: snapshot.val().boatName,
          photoUrl: snapshot.val().photoUrl,
          anglerName: snapshot.val().anglerName,
          anglerId: snapshot.val().anglerId,
          speciesId: snapshot.val().speciesId,
          speciesName: snapshot.val().speciesName,
          status: snapshot.val().status,
          hookedupDate: hd,
          catchDate: cd,
        }
      })
    
    setTimeout(function() { this.setState({playing: 'STOPPED'}); }.bind(this), 4000);
    setTimeout(function() { this.setState({newLog: false}); }.bind(this), 10000);
    setTimeout(function() { this.setState({videoVis: 'visible', displayVis: 'inline'}); }.bind(this), 10000);
  }
  
  sortLogs(logs){
    logs.sort(function(a,b){
      var c = new Date(a.catchDate);
      var d = new Date(b.catchDate);
      return c-d;
    });
    
    logs.reverse();
    this.getBoats();
  }
  
  handleFishLogChanged = (snapshot, last) => {
    var logs = this.state.fishLogs;
    var vidLogs = this.state.vidLogs;
    if(snapshot.val().catchDate) {
      var cd = this.formatDate(snapshot.val().catchDate);
    } else {
      var cd = null;
    }
    if(snapshot.val().hookedupDateDate) {
      var hd = this.formatDate(snapshot.val().hookedupDateDate);
    } else {
      var hd = null;
    }
    vidLogs.push({
      id: snapshot.key,
      boatId: snapshot.val().boatId,
      boatName: snapshot.val().boatName,
      speciesId: snapshot.val().speciesId,
      speciesName: snapshot.val().speciesName,
      lbs: snapshot.val().fishLbs,
      anglerId: snapshot.val().anglerId,
      anglerName: snapshot.val().anglerName,
      catchDate: this.formatDate(snapshot.val().catchDate),
      clipUrl: snapshot.val().clipUrl,
      status: snapshot.val().status
    })
    logs.map(log => {
      if(log.id === snapshot.key) {
        log.lbs = snapshot.val().fishLbs;
        log.boatId = snapshot.val().boatId;
        log.boatName = snapshot.val().boatName;
        log.speciesId = snapshot.val().speciesId;
        log.speciesName = snapshot.val().speciesName;
        log.anglerId = snapshot.val().anglerId;
        log.anglerName = snapshot.val().anglerName;
        log.catchDate = this.formatDate(snapshot.val().catchDate);
        log.clipUrl = snapshot.val().clipUrl;
        log.status = snapshot.val().status;
      }
    });
    
    this.setState({
      vidLogs,
      fishLogs:logs,
    })
    
    if(snapshot.val().fishLbs && snapshot.val().fishLbs > 0) {
      this.setState({
        playing: 'PLAYING',
        newLog: true,
        videoVis: 'hidden',
        displayVis: 'none',
        newFishLog: {
          boatId: snapshot.val().boatId,
          boatName: snapshot.val().boatName,
          photoUrl: snapshot.val().photoUrl,
          anglerName: snapshot.val().anglerName,
          anglerId: snapshot.val().anglerId,
          speciesId: snapshot.val().speciesId,
          speciesName: snapshot.val().speciesName,
          fishLbs: snapshot.val().fishLbs,
          status: snapshot.val().status,
          hookedupDateDate: hd,
          catchDate: cd,
        }
    })
    setTimeout(function() { this.setState({playing: 'PAUSED'}); }.bind(this), 4000);
    setTimeout(function() { this.setState({newLog: false}); }.bind(this), 10000);
    setTimeout(function() { this.setState({videoVis: 'visible', displayVis: 'inline'}); }.bind(this), 10000);
    }
    this.getBoats();
  }
  
  getBoats() {
    var logs = this.state.fishLogs;
    var boats = this.state.boats;
    var boatLogs = [];
    var boatLogsOne = [];
    var boatLogsTwo = [];
    var boatLogsThree = [];
    var boatLogsFour = [];
    boats.forEach((boat) => {
      var boatFish = [];
      var boatFishOne = [];
      var boatFishTwo = [];
      var boatFishThree = [];
      var boatFishFour = [];
      
      //Get FishLog for each Boat
      logs.forEach((fishLog) => {
        if(!fishLog.catchDate){
          return
        }
        if(boat.id === fishLog.boatId){
          if(fishLog.length !== 0) {
            boatFish.push(fishLog);
          }
        }
        if(moment(this.state.tourDay1).format('l') === moment(fishLog.catchDate).format('l')) {
          if(boat.id === fishLog.boatId){
            if(fishLog.length !== 0) {
              boatFishOne.push(fishLog);
            }
          }
        } else if(moment(this.state.tourDay2).format('l') === moment(fishLog.catchDate).format('l')) {
          
          if(boat.id === fishLog.boatId){
            if(fishLog.length !== 0) {
              boatFishTwo.push(fishLog);
            }
          }
          
        } else if(moment(this.state.tourDay3).format('l') === moment(fishLog.catchDate).format('l')) {
          if(boat.id === fishLog.boatId){
            if(fishLog.length !== 0) {
              boatFishThree.push(fishLog);
            }
          }
        } else if(moment(this.state.tourDay4).format('l') === moment(fishLog.catchDate).format('l')) {
          if(boat.id === fishLog.boatId){
            if(fishLog.length !== 0) {
              boatFishFour.push(fishLog);
            }
          }
        }
      });
      
      if(boatFish.length !== 0) {
        boatFish.sort(function(a, b) {
            var dateA = new Date(a.catchDate), dateB = new Date(b.catchDate);
            return dateA - dateB;
        });
        var lastFishInt = (boatFish.length - 1);
        var lastFishTime = boatFish[lastFishInt].catchDate;
        var d = new Date(lastFishTime);
        boatLogs.push({
          boatId: boat.id,
          boatName: boat.name,
          boatThm: boat.photoURL,
          boatCaughtFish: boatFish,
          lastFishTime:  lastFishTime,
          lastTime: parseInt(Math.round(d.getTime() / 1000))
        });
      }
      if(boatFishOne.length !== 0) {
        var lastFishIntOne = (boatFishOne.length - 1);
        var lastFishTimeOne = boatFishOne[lastFishIntOne].catchDate;
        var dOne = new Date(lastFishTimeOne);
        boatLogsOne.push({
          boatId: boat.id,
          boatName: boat.name,
          boatThm: boat.photoURL,
          boatCaughtFish: boatFishOne,
          lastFishTime:  lastFishTimeOne,
          lastTime: parseInt(Math.round(dOne.getTime() / 1000))
        });
      } 
      
      if(boatFishTwo.length !== 0) {
        var lastFishIntTwo = (boatFishTwo.length - 1);
        var lastFishTimeTwo = boatFishTwo[lastFishIntTwo].catchDate;
        var dTwo = new Date(lastFishTimeTwo);
        boatLogsTwo.push({
          boatId: boat.id,
          boatName: boat.name,
          boatThm: boat.photoURL,
          boatCaughtFish: boatFishTwo,
          lastFishTime:  lastFishTimeTwo,
          lastTime: parseInt(Math.round(dTwo.getTime() / 1000))
        });
      }
      if(boatFishThree.length !== 0) {
        var lastFishIntThree = (boatFishThree.length - 1);
        var lastFishTimeThree = boatFishThree[lastFishIntThree].catchDate;
        var dThree = new Date(lastFishTimeThree);
        boatLogsThree.push({
          boatId: boat.id,
          boatName: boat.name,
          boatThm: boat.photoUrl,
          boatCaughtFish: boatFishThree,
          lastFishTime:  lastFishTimeThree,
          lastTime: parseInt(Math.round(dThree.getTime() / 1000))
        });
      }
      
      if(boatFishFour.length !== 0) {
        var lastFishIntFour = (boatFishFour.length - 1);
        if(lastFishIntFour) {
          var lastFishTimeFour = boatFishFour[lastFishIntFour].catchDate;
          var dFour = new Date(lastFishTimeFour);
          boatLogsFour.push({
            boatId: boat.id,
            boatName: boat.name,
            boatThm: boat.photoUrl,
            boatCaughtFish: boatFishFour,
            lastFishTime: lastFishTimeFour,
            lastTime: parseInt(Math.round(dFour.getTime() / 1000))
          });
        }
      }
    });
    
    var bTotals = this.getBoatTotals(boatLogs);
    var bTotalsOne = this.getBoatTotals(boatLogsOne);
    var bTotalsTwo = this.getBoatTotals(boatLogsTwo);
    var bTotalsThree = this.getBoatTotals(boatLogsThree);
    var bTotalsFour = this.getBoatTotals(boatLogsFour);
    
    this.setState({
      currentLogs: boatLogs,
      logs: boatLogs,
      logsOne: boatLogsOne,
      logsTwo: boatLogsTwo,
      logsThree: boatLogsThree,
      logsFour: boatLogsFour,
      boatScores: this.scoreSortFilter(bTotals),
      boatScoresOne: this.scoreSortFilter(bTotalsOne),
      boatScoresTwo: this.scoreSortFilter(bTotalsTwo),
      boatScoresThree: this.scoreSortFilter(bTotalsThree),
      boatScoresFour: this.scoreSortFilter(bTotalsFour),
    })
    setTimeout(this.toggleLoading, 3000)
  }

  toggleLoading = () => {
    this.setState({
        loading: false,
        loadingVis: 'inline',
        loadingVis2: 'none',
      });
  }

  getBoatTotals(bLogs) {
    var boatTotals = [];
    bLogs.forEach((boatLog) => {
      var logs = boatLog.boatCaughtFish;
      var sps = this.state.species;
      var boatCounts = [];
      var boatPoints = [];
      var boatLbsPoints = [];
      var boatTotal = '';
      
      sps.forEach((specie) => {
        var speciesId = specie.id
        var speciesName = specie.name;
        var speciesPoints = specie.points;
        var scoreType = specie.scoreType;
        var speciesCount = [];
        var speciesScores = 0;
         
        if (scoreType === 'QTY'){
          logs.forEach((log) => {
            if(specie.id === log.speciesId) {
              speciesCount.push(log.id);
            }
          }); 
          var count = speciesCount.length;
          var points = parseFloat(count * speciesPoints);
          var totalPoints = (points + speciesScores)
          boatCounts.push({
            id: speciesId,
            boatName: boatLog.boatName,
            boatThm: boatLog.boatThm,
            speciesName: speciesName,
            speciesCount: speciesCount.length,
            speciesPoints: totalPoints
          });
          boatPoints.push(totalPoints);
        }
        if (scoreType === 'LBS'){
          logs.forEach((log) => {
            if(specie.id === log.speciesId) {
              speciesCount.push(log.id);
              speciesPoints = speciesPoints * log.lbs;
            }
          });
          if(speciesCount.length > 0) {
            boatCounts.push({
            id: speciesId,
            boatName: boatLog.boatName,
            boatThm: boatLog.boatThm,
            speciesName: speciesName,
            speciesCount: speciesCount.length,
            speciesPoints
          });
          }
          boatLbsPoints.push(totalPoints);
        }
      });
      boatTotal = boatPoints.reduce(function(sum, value) {
        return sum + value;
      }, 0);
      boatTotals.push({
        id: boatLog.boatId,
        boatName: boatLog.boatName,
        boatThm: boatLog.boatThm,
        speciesCounts: boatCounts,
        total: boatTotal,
        lastFishTime: this.formatDate(boatLog.lastFishTime),
        lastTime: boatLog.lastFishTime
      })
    })
    return boatTotals
  }

  scoreSortFilter(boatScores) {
    Array.prototype.sortOn = function(key, key2){
      this.sort(function(a, b){
          if(a[key] < b[key]){
              return -1;
          }else if(a[key] > b[key]){
              return 1;
          } else {
            if(a[key2] > b[key2]){
              return -1;
            }else if(a[key2] < b[key2]){
              return 1;
            }
          }
          return 0;
      });
    }
    
    boatScores.sortOn("total", "lastTime");
    boatScores.reverse();
    function isNumber(obj) {
      return obj!== undefined && typeof(obj) === 'number' && !isNaN(obj);
    }

    function filterByTotal(item) {
      if (isNumber(item.total)) {
        return true;
      } 
      return false; 
    }
    var boatScoresArray = boatScores.filter(filterByTotal);
    
    var rank = 1;
    var bScores = [];
    boatScoresArray.forEach((boat) => {
      bScores.push({
        rank: rank++,
        boat: boat
      })
    })
    return bScores;  
  }

  formatDate(date) {
    var options = {
      month: 'short', day: 'numeric',
      hour: 'numeric', minute: 'numeric',
      hour12: true,
      timeZone: 'America/Costa_Rica',
    };
    var newDate = new Date(date);
    var formattedDate = new Intl.DateTimeFormat('en-US', options).format(newDate);

    return formattedDate;
  }

  catchDate(date) {
    var catchDate = new Date(date)
    var hour = catchDate.getHours();
    var secs = catchDate.getSeconds();
    var ampm = hour >= 12 ? 'PM' : 'AM';
    var minutes = catchDate.getMinutes();
    hour = hour % 12;
    hour = hour ? hour : 12;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var dateString = hour + ':' + minutes + ':' + secs + '' + ampm;
    
    return dateString
  }

  nextVideo(currentVideo) {
    const videos = this.state.vidLogs;
    var i = videos.length - 1;
    var index = videos.indexOf(currentVideo);
    if(index !== i) {
      var next = index + 1;
    } else {
      var next = 0;
    }
    this.setState({
      currentVideo: videos[next]
    })
  }

  _toggleDailysAll = () => {
    var currentLogs = this.state.logs
    this.setState({
      currentLogs
    })
  }
  
  _toggleDailysOne = () => {
    var currentLogs = this.state.logsOne
    this.setState({
      currentLogs
    })
  }
  _toggleDailysTwo = () => {
    var currentLogs = this.state.logsTwo
    this.setState({
      currentLogs
    })
  }
  _toggleDailysThree = () => {
    var currentLogs = this.state.logsThree
    this.setState({
      currentLogs
    })
  }
  _toggleDailysFour = () => {
    var currentLogs = this.state.logsFour
    this.setState({
      currentLogs
    })
  }

  render () {
    if(this.state.newFishLog.photoUrl) {
      var imageUrl = this.state.newFishLog.photoUrl;
    } else {
      var imageUrl = 'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/default_boat.jpg?alt=media&token=b8c971f7-0a9b-4433-8516-ff0c7a3b7a7e';
    }
    if(this.state.newLog) {
      var popBox = 
          <div className="popContainer">
              <div
                id="boatContainer" 
                style={{
                  backgroundImage: 'url(' +  imageUrl  + ')',
                  flex: 1,
                  minHeight: '450px',
                  backgroundSize: 'cover',
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: '50% 50%',
                }}>
                  <div className="caughtBox">
                    <center> 
                      {this.state.newFishLog.catchDate ? 'CAUGHT FISH!!' : 'HOOKED UP'}
                    </center>
                  </div>
                  <div className="detailsBox">
                    <div 
                      className="speciesFlag" 
                      style={{
                        width: '100px',
                        height: '50px',
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: '50% 50%',
                        backgroundImage: 'url(' +  this.state.speciesRaw[this.state.newFishLog.speciesId].speciesImageUri  + ')'
                      }}/>
                    <div className="boatNameContainer">
                      {this.state.newFishLog.boatName}
                    </div>
                    <div className="anglerName">
                      {this.state.newFishLog.anglerName}
                    </div>
                    <div className="dateBox">
                      {this.catchDate(this.state.newFishLog.catchDate)}
                    </div> 
                  </div> 
                  { this.state.newFishLog.fishLbs ? <center><div className="fishLbs">
                      {this.state.newFishLog.fishLbs} LBS
                    </div></center> : null }
               </div>
            </div>
    } else {
      var popBox = <div style={{width: '100%', justifyContent:'center', alignItems: 'center'}}>
                        <center>
                          <div className="videoContainer">
                            <ReactPlayer 
                              url={this.state.currentVideo.clipUrl}
                              controls={true}
                              width={'100%'}
                              height={450}
                              volume={.5}
                              muted={false}
                              playsinline={true}
                              onEnded={() => {
                                this.nextVideo(this.state.currentVideo)
                              }}
                              playing>
                            </ReactPlayer>
                          </div>
                        </center>
                      </div>;
    }

    if(this.state.newLog) {
      var popMobileBox = 
          <div className="popContainer">
              <div
                id="boatMobileContainer" 
                style={{
                  backgroundImage: 'url(' +  imageUrl  + ')',
                  Height: '250px',
                  backgroundSize: 'cover',
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: '50% 50%',
                }}>
                  <div className="caughtBoxMobile">
                    <center> 
                      {this.state.newFishLog.catchDate ? 'CAUGHT FISH!!' : 'HOOKED UP'}
                    </center>
                  </div>
                  <div className="detailsBoxMobile">
                    <div 
                      className="speciesFlag" 
                      style={{
                        width: '80px',
                        height: '40px',
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: '50% 50%',
                        backgroundImage: 'url(' +  this.state.speciesRaw[this.state.newFishLog.speciesId].speciesImageUri  + ')'
                      }}/>
                    <div className="boatNameContainerMobile">
                      {this.state.newFishLog.boatName}
                    </div>
                    <div className="anglerNameMobile">
                      {this.state.newFishLog.anglerName}
                    </div>
                    <div className="dateBoxMobile">
                      {this.catchDate(this.state.newFishLog.catchDate)}
                    </div>
                  </div> 
                    { this.state.newFishLog.fishLbs ? <div className="fishLbsPhone">
                      {this.state.newFishLog.fishLbs} LBS
                    </div> : null }
               </div>
            </div>
    } else {
      var popMobileBox = 
        <div style={{width: '100%', justifyContent:'center', alignItems: 'center'}}>
          <center>
            <div className="videoContainer"> 
              <ReactPlayer 
                url={this.state.currentVideo.clipUrl}
                controls={true}
                width={'100%'}
                height={250}
                volume={.5}
                muted={false}
                playsinline={true}
                onEnded={() => {
                  this.nextVideo(this.state.currentVideo)
                }}
                playing>
              </ReactPlayer>
            </div>
          </center>
        </div>;
    }
    
    if(this.state.newLog) {
      var popBoxTv = 
          <div className="popContainer">
              <div
                id="boatTVContainer" 
                style={{
                  backgroundImage: 'url(' +  imageUrl  + ')',
                  Height: '600px',
                  backgroundSize: 'cover',
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: '50% 50%',
                }}>
                  <div className="caughtBoxTv">
                    <center> 
                      {this.state.newFishLog.catchDate ? 'CAUGHT FISH!!' : 'HOOKED UP'}
                    </center>
                  </div>
                  <div className="detailsBoxTv">
                    <div 
                      className="speciesFlag" 
                      style={{
                        width: '80px',
                        height: '40px',
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: '50% 50%',
                        backgroundImage: 'url(' +  this.state.speciesRaw[this.state.newFishLog.speciesId].speciesImageUri  + ')'
                      }}/>
                    <div className="boatNameContainerTv">
                      {this.state.newFishLog.boatName}
                    </div>
                    <div className="anglerNameTv">
                      {this.state.newFishLog.anglerName}
                    </div>
                    <div className="dateBoxTv">
                      {this.catchDate(this.state.newFishLog.catchDate)}
                    </div>
                  </div> 
                    { this.state.newFishLog.fishLbs ? <div className="fishLbsTv">
                      {this.state.newFishLog.fishLbs} LBS
                    </div> : null }
               </div>
            </div>
    } else {
      var popBoxTv = null;
    }
    
    return (
      <div className="main-container">
          <TelevisionBreakpoint>
            <div style={{zIndex: -1, display: this.state.loadingVis, padding: '5%'}}>
              <div className="scroller_rowTv" style={{
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: '50% 0%',
                backgroundImage: 'url(https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/tournamentLogos%2Fbisbeesbnbbanner.jpg?alt=media&token=42e26a24-bb72-428c-a28b-b501bbb49417)'
              }}>
                <div className="headerBox">
                  {this.state.logs.length > 0 ? <center><MultiSpeciesHeaviest logs={this.state.logs} tourLogo={this.state.tournamentLogo} speciesIds={['-LK2pd5wc7njJFQzl7AQ', '-LK2psdukA1NDM3hIzum']} /></center> : <div style={{height: 170, flex: 1, display: 'flex', justifyContent: 'flex-start', alignItems: 'center'}}><div className='tourLogo' 
                    style={{
                      backgroundSize: 'contain',
                      backgroundRepeat: 'no-repeat',
                      backgroundPosition: '50% 50%',
                      width: 250, 
                      height: 150,
                      backgroundImage: 'url(' +  this.state.tournamentLogo  + ')'
                    }} /></div>}
                </div>
                <div className="headerBox2">
                    {this.state.logs.length > 0 ? <center><Scroller logs={this.state.logs} species={this.state.species}/></center>: null}
                  
                  {this.state.boatScores.length > 0 ? null : 
                    <div style={{height: 170, flex: 1, display: 'flex', justifyContent: 'flex-end', alignItems: 'center'}}>
                    <div className="countBox">
                      <center>
                        <div className="countdownTitle">Countdown to Lines In</div>
                        <Countdown 
                          date={this.state.countDownDate}
                          renderer={props => 
                            <div className="countDownRow">
                              <div className="countDownBoxTv">{props.days} <br />Days</div>
                              <div className="countDownBoxTv">{props.hours}<br />Hrs</div>
                              <div className="countDownBoxTv">{props.minutes}<br />Mins</div>
                              <div className="countDownBoxTv">{props.seconds}<br />Secs</div>
                            </div>
                          }
                           /> 
                        </center>
                        </div>
                      </div>
                    }
                </div>
              </div>
              <div className="row2">
                 <div className="tvColumn">
                   { popBoxTv }
                    <div style={{
                      display: this.state.displayVis,
                      width: '100%', 
                      justifyContent:'center', alignItems: 'center'}}>
                      <center>
                        <div className="videoContainer"> 
                          <ReactPlayer 
                            url={this.state.currentVideo.clipUrl}
                            controls={true}
                            width={'100%'}
                            height={600}
                            volume={.5}
                            muted={true}
                            playsinline={true}
                            onEnded={() => {
                              this.nextVideo(this.state.currentVideo)
                            }}
                            playing={this.state.vidPlaying}>
                          </ReactPlayer>
                        </div>
                      </center>
                    </div>
                </div>
                {this.state.logs.length > 0 ? <div className="logBox">
                  <div className="logColumn">
                    {this.isEmpty(this.state.speciesRaw) ? null : <LogsTv slidesToShow={6} hookups={this.state.hookups} logs={this.state.fishLogs} speciesRaw={this.state.speciesRaw} boatsRaw={this.state.boatsRaw} anglersRaw={this.state.anglersRaw} tourLogo={this.state.tournamentLogo}/> }
                  </div>
                </div> : 
                <div style={{width: '45%'}}>
                  <TournamentDetailsTv tournament={this.state.tournament} /> 
                  <center><TideChart tournamentId={this.state.tournamentId} /></center>
                </div>
                }
              </div>
                <div style={{height: '150px', backgroundColor: '#fff'}}>
                 <SponsorsScrollerTv sponsors={ sponsorLogos } slides={6}/>
                </div>
                {this.state.logs.length > 0 ? <div className="speciesRow">
                  <SpeciesScoresSingle speciesId={'-LK2qOnYGSZ0yQ0JTBUv'} speciesName={'Dorado'} logs={this.state.logs} />
                  <SpeciesScoresSingle speciesId={'-LK2qRXVuK8R9f0KofC4'} speciesName={'Tuna'} logs={this.state.logs} />
                </div> : null }
              </div>
              <div className="loading" style={{width: '100%', display: this.state.loadingVis2}}>
                <div className="rowLoading">
                  <img src={this.state.tournamentLogo} width='50%' alt='Tournamant Logo'/>
                  </div>
              </div>
            </TelevisionBreakpoint>
          <DesktopBreakpoint>
            <div style={{zIndex: -1, display: this.state.loadingVis}}>
              <div className="scroller_rowTv" style={{
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: '50% 0%',
                backgroundImage: 'url(https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/tournamentLogos%2Fbisbeesbnbbanner.jpg?alt=media&token=42e26a24-bb72-428c-a28b-b501bbb49417)'
              }}>
                <div className="headerBox">
                  {this.state.logs.length > 0 ? <center><MultiSpeciesHeaviest logs={this.state.logs} tourLogo={this.state.tournamentLogo} speciesIds={['-LK2pd5wc7njJFQzl7AQ', '-LK2psdukA1NDM3hIzum']} /></center> : <div style={{height: 170, flex: 1, display: 'flex', justifyContent: 'flex-start', alignItems: 'center'}}><div className='tourLogo' 
                    style={{
                      backgroundSize: 'contain',
                      backgroundRepeat: 'no-repeat',
                      backgroundPosition: '50% 50%',
                      width: 250, 
                      height: 150,
                      backgroundImage: 'url(' +  this.state.tournamentLogo  + ')'
                    }} /></div>}
                </div>
                <div className="headerBox2">
                  
                    {this.state.logs.length > 0 ? <center><Scroller logs={this.state.logs} species={this.state.species}/></center>: null}
                  
                  {this.state.boatScores.length > 0 ? null : 
                    <div style={{height: 170, flex: 1, display: 'flex', justifyContent: 'flex-end', alignItems: 'center'}}>
                    <div className="countBox">
                      <center>
                      <div className="countdownTitle">Countdown to Lines In</div>
                      <Countdown 
                        date={this.state.countDownDate}
                        renderer={props => 
                          <div className="countDownRow">
                            <div className="countDownBox">{props.days} <br />Days</div>
                            <div className="countDownBox">{props.hours}<br />Hrs</div>
                            <div className="countDownBox">{props.minutes}<br />Mins</div>
                            <div className="countDownBox">{props.seconds}<br />Secs</div>
                          </div>
                        }
                         /> 
                      </center>
                      </div>
                      </div>
                    }
                </div>
              </div>
              <div className="row2">
                 <div className="tvColumn">
                   { popBox }
                </div>
                {this.state.logs.length > 0 ? <div className="logBox">
                  <div className="logColumn">
                    {this.isEmpty(this.state.speciesRaw) ? null : <Logs slidesToShow={6} hookups={this.state.hookups} logs={this.state.fishLogs} speciesRaw={this.state.speciesRaw} boatsRaw={this.state.boatsRaw} anglersRaw={this.state.anglersRaw} tourLogo={this.state.tournamentLogo}/> }
                  </div>
                </div> : <TournamentDetails tournament={this.state.tournament} /> }
              </div>
                <div style={{height: '100px', backgroundColor: '#fff'}}>
                 <SponsorsScroller sponsors={ sponsorLogos } slides={6}/>
                </div>
                {this.state.logs.length > 0 ? <div className="speciesRow">
                  <SpeciesScoresSingle speciesId={'-LK2qOnYGSZ0yQ0JTBUv'} speciesName={'Dorado'} logs={this.state.logs} />
                  <SpeciesScoresSingle speciesId={'-LK2qRXVuK8R9f0KofC4'} speciesName={'Tuna'} logs={this.state.logs} />
                </div> : null}
                <center><TideChart tournamentId={this.state.tournamentId} /></center>
              </div>
              <div className="loading" style={{width: '100%', display: this.state.loadingVis2}}>
                <div className="rowLoading">
                  <img src={this.state.tournamentLogo} width='50%' alt='Tournamant Logo'/>
                  </div>
              </div>
            </DesktopBreakpoint>
            <TabletBreakpoint>
            <div style={{zIndex: -1, display: this.state.loadingVis}}>
                <div style={{
                      width: '100%', 
                      height: '170px', 
                      backgroundSize: 'cover',
                      backgroundRepeat: 'no-repeat',
                      backgroundPosition: '50% 0%',
                      backgroundImage: 'url(https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/tournamentLogos%2Fbisbeesbnbbanner.jpg?alt=media&token=42e26a24-bb72-428c-a28b-b501bbb49417)'}}>
                  <center>
                  {this.state.logs.length > 0 ? <MultiSpeciesHeaviest logs={this.state.logs} speciesIds={['-LK2pd5wc7njJFQzl7AQ', '-LK2psdukA1NDM3hIzum']} />: 
                    <div style={{height: 170, flex: 1, display: 'flex', justifyContent: 'flex-end', alignItems: 'center'}}>
                    <div className='tourLogo' 
                    style={{
                      backgroundSize: 'contain',
                      backgroundRepeat: 'no-repeat',
                      backgroundPosition: '50% 50%',
                      width: 150, 
                      height: 100,
                      backgroundImage: 'url(' +  this.state.tournamentLogo  + ')'
                    }} /></div> }
                  </center>
                </div>
                <div style={{width: '100%', height: '170px'}}>
                  <center>
                   {this.state.logs.length > 0 ? <Scroller logs={this.state.logs} species={this.state.species} /> : null }
                   </center>
                    {this.state.boatScores.length > 0 ? null : 
                      <div style={{height: 170, flex: 1, display: 'flex', justifyContent: 'flex-end', alignItems: 'center'}}>
                      <div className="countBox">
                      <center>
                      <div className="countdownTitlePhone">Countdown to Lines In</div>
                      <Countdown 
                        date={this.state.countDownDate}
                        renderer={props => 
                          <div className="countDownRow">
                            <div className="countDownBox">{props.days} <br />Days</div>
                            <div className="countDownBox">{props.hours}<br />Hrs</div>
                            <div className="countDownBox">{props.minutes}<br />Mins</div>
                            <div className="countDownBox">{props.seconds}<br />Secs</div>
                          </div>
                        }
                         /> 
                      </center>
                      </div> 
                      </div>
                    }
                </div>
                <div className="row2">
                  <div className="tvColumn">
                    { popBox }
                  </div>
                  {this.state.logs.length > 0 ? <div className="logBox">
                    <div className="logColumn">
                      {this.isEmpty(this.state.speciesRaw) ? null : <Logs slidesToShow={6} hookups={this.state.hookups} logs={this.state.fishLogs} speciesRaw={this.state.speciesRaw} boatsRaw={this.state.boatsRaw} anglersRaw={this.state.anglersRaw}/> }
                    </div>
                  </div> : <TournamentDetails tournament={this.state.tournament} />}
                </div>
                 <div style={{height: '100px', backgroundColor: '#fff'}}>
                   <SponsorsScroller sponsors={ sponsorLogos } slides={6}/>
                 </div>
                {this.state.logs.length > 0 ? <div className="speciesRow">
                  <SpeciesScores speciesId={'-LK2qOnYGSZ0yQ0JTBUv'} speciesName={'Dorado'} logs={this.state.logs} />
                  <SpeciesScores speciesId={'-LK2qRXVuK8R9f0KofC4'} speciesName={'Tuna'} logs={this.state.logs} />
                </div> : null}
                <center><TideChart tournamentId={this.state.tournamentId} /></center>
              </div>
              <div className="loading" style={{width: '100%', display: this.state.loadingVis2}}>
                <div className="rowLoading">
                  <img src={this.state.tournamentLogo} width='50%' alt='Tournament Logo'/>
                  </div>
              </div>
            </TabletBreakpoint>
            <PhoneBreakpoint>    
            <div style={{display: this.state.loadingVis}}>
                <div style={{
                      flex: 1, 
                      height: '140px', 
                      backgroundSize: 'cover',
                      backgroundRepeat: 'no-repeat',
                      backgroundPosition: '50% 0%',
                      backgroundImage: 'url(https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/tournamentLogos%2Fbisbeesbnbbanner.jpg?alt=media&token=42e26a24-bb72-428c-a28b-b501bbb49417)'}}>
                  <center>
                  {this.state.logs.length > 0 ? <MultiSpeciesScoresHorzPhone logs={this.state.logs} tiles={3} speciesIds={['-LK2pd5wc7njJFQzl7AQ', '-LK2psdukA1NDM3hIzum']} /> : <div className='tourLogo' 
                    style={{
                      backgroundSize: 'contain',
                      backgroundRepeat: 'no-repeat',
                      backgroundPosition: '50% 50%',
                      width: 150, 
                      height: 100,
                      backgroundImage: 'url(' +  this.state.tournamentLogo  + ')'
                    }} /> }
                  </center>
                    {this.state.logs.length > 0 ? <div className="scrollerTitleMobile">Weight Division</div> : null }
                </div>
                <div style={{flex: 1, height: '140px', marginBottom: '5px'}}>
                  <center>
                  {this.state.logs.length > 0 ? <ScrollerMobile species={this.state.species} logs={this.state.logs} tiles={4} /> : null }
                  </center>
                  {this.state.logs.length > 0 ? <div className="scrollerTitleMobile">Release Division</div> : <div className="countBox">
                      <center>
                      <div className="countdownTitlePhone">Countdown to Lines In</div>
                      <Countdown 
                        date={this.state.countDownDate}
                        renderer={props => 
                          <div className="countDownRow">
                            <div className="countDownBox">{props.days} <br />Days</div>
                            <div className="countDownBox">{props.hours}<br />Hrs</div>
                            <div className="countDownBox">{props.minutes}<br />Mins</div>
                            <div className="countDownBox">{props.seconds}<br />Secs</div>
                          </div>
                        }
                         /> 
                      </center>
                      </div>
                    }
                </div>
                  <div className="tvColumn">
                    { popMobileBox }
                  </div>
                  <div style={{height: '100px', backgroundColor: '#fff'}}>
                    <SponsorsScroller sponsors={ sponsorLogos } slides={3}/>
                  </div>
                  <div className="logBoxPhone">
                    {this.state.logs.length > 0 ? <div>
                    <SpeciesScoresPhone speciesId={'-LK2qOnYGSZ0yQ0JTBUv'} speciesName={'Dorado'} logs={this.state.logs} />
                    <SpeciesScoresPhone speciesId={'-LK2qRXVuK8R9f0KofC4'} speciesName={'Tuna'} logs={this.state.logs} />
                  </div> : 
                    <div>
                    <TournamentDetailsPhone tournament={this.state.tournament} />
                    <center><TideChartPhone tournamentId={this.state.tournamentId} />
                      <iframe width="100%" height="250" src="https://embed.windy.com/embed2.html?zoom=4&level=surface&overlay=wind&menu=&message=true&marker=&calendar=&pressure=true&type=map&location=coordinates&metricWind=default&metricTemp=default&radarRange=-1" frameBorder="0"></iframe>
                    </center>
                  </div>
                    }
                    <div className="logColumn">
                      <center>
                      {this.isEmpty(this.state.speciesRaw) ? <TournamentDetailsPhone tournament={this.state.tournament} /> : <LogsPhone slidesToShow={6} hookups={this.state.hookups} logs={this.state.fishLogs} speciesRaw={this.state.speciesRaw} boatsRaw={this.state.boatsRaw} anglersRaw={this.state.anglersRaw}/> }
                      </center>
                    </div>
                  </div>
              </div>}
              <div className="loading" style={{width: '100%', display: this.state.loadingVis2}}>
                <div className="rowLoading">
                  <img src={this.state.tournamentLogo} width='50%' alt='Tournament Logo'/>
                  </div>
              </div>
            </PhoneBreakpoint>
          { this.state.playing ? <Sound
              url={dragSound}
              playStatus={this.state.playing}
              />: null }
      </div> 
    );
  }
}

export default BisbeesLosCabos;


// WEBPACK FOOTER //
// ./src/pages/tournaments/BisbeesLosCabos.js